import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    showText: { default: '点击可在下方复制当前行' },
    rowIndex: null
  },
  emits: ['copyClick'],
  setup(__props: any, { emit: emits }) {

const props = __props as { showText: string, rowIndex?: number }



function handleCopy() {
  emits('copyClick')
}

return { __sfc: true,props, emits, handleCopy }
}

})